import React from "react";
import { FormControl, Switch } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import { styled } from "@mui/material/styles";

const SwitchAdapter = ({ name, input, meta, label, ...rest }) => {
  // Set the checked state based on initialValue

  return (
    <FormControl error={meta.error && meta.touched} {...rest}>
      <FormControlLabel
        label={label}
        labelPlacement="start"
        control={
          <Android12Switch
            name={name}
            checked={input.checked} // Use the checked state here
            onChange={input.onChange}
            value={input.value}
            size="xs"
          />
        }
      />
    </FormControl>
  );
};

const Android12Switch = styled(Switch)(({ _theme }) => ({
  padding: 8,
  width: 78,
  height: 45,
  "& .MuiSwitch-track": {
    borderRadius: 30 / 2,
    "&:before, &:after": {
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      width: 16,
      height: 16,
      color: "primary",
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "none",
    width: 22.5,
    height: 22.5,
    margin: 2,
  },
  "& .MuiSwitch-switchBase": {
    "&.Mui-checked": {
      color: "white",
      transform: "translateX(33px)",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: "green",
        "&:before": {
          content: '"YES"',
          color: "white",
          left: 15,
          top: 23,
          fontFamily: "Arial,Helvetica,sans-seriff",
          fontSize: 13,
        },
      },
    },

    color: "white",
    "& + .MuiSwitch-track": {
      opacity: 1,
      backgroundColor: "red",
      "&:before": {
        content: '"NO"',
        color: "white",
        left: 40,
        top: 23,
        fontFamily: "Arial,Helvetica,sans-seriff",
        fontSize: 13,
      },
    },
  },
}));

export default SwitchAdapter;
